import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import type {
  LandingAssistantChatRequestDto,
  LandingAssistantChatResponseDto,
  LandingLeadResultDto,
  SubmitLandingLeadDto,
} from '../models/landing-assistant/landing-assistant.models';

@Injectable({ providedIn: 'root' })
export class LandingAssistantService {
  private readonly http = inject(HttpClient);

  private apiUrl(path: string): string {
    const base = environment.apiBaseUrl.replace(/\/+$/, '');
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${base}${p}`;
  }

  sendMessage(body: LandingAssistantChatRequestDto): Observable<LandingAssistantChatResponseDto> {
    return this.http.post<LandingAssistantChatResponseDto>(this.apiUrl('/api/LandingAssistant/chat'), body);
  }

  submitLead(body: SubmitLandingLeadDto): Observable<LandingLeadResultDto> {
    return this.http.post<LandingLeadResultDto>(this.apiUrl('/api/LandingAssistant/lead'), body);
  }
}
